import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GenesisUnitOfWork } from '../../core/core.module';
import _ from 'lodash';

@Component({
    selector: 'app-sales-email-dialog',
    templateUrl: './sales-email-dialog.component.html',
    styleUrls: ['./sales-email-dialog.component.scss'],
    standalone: false
})
export class SalesEmailDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();

    emailAddressId: number;
    emailAddress: any;

    constructor(private uow: GenesisUnitOfWork, public modalRef: BsModalRef) {}

    async ngOnInit() {
        if (!!this.emailAddressId) this.emailAddress = await this.uow.emailAddresses.byId(this.emailAddressId);
        else this.emailAddress = this.uow.emailAddresses.createEntity();
    }

    async save() {
        await this.uow.commit();
        this.result.next(true);
    }

    cancel(): void {
        this.uow.rollback();
        this.result.next(false);
    }
}
